import { useCallback, useContext, useEffect, useState } from "react";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import Navbar from "./Navbar";
import Sidebar from "./Sidebars";
import Breadcrumbs from "../../context/BreadCrumb";
import { BreadcrumbProvider } from "../../context/BreadcrumbContext";
import AuthContext from "../../auth/AuthContext";
import AlertService from "../../services/AlertService";
import MenuService from "../../services/MenuService";

const MainLayout = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const authContext = useContext(AuthContext);
  const navigate = useNavigate();
  const location = useLocation();
  const [menus, setMenus] = useState([]);

  const formatMenu = useCallback((menu) => ({
    name: menu.displayText,
    path: menu.routerLink,
    icon: menu.iconName,
    children: menu.child?.map(formatMenu) || [],
  }), []);


  useEffect(() => {
    if (authContext.mfaSetupEnabled && !authContext.mfaSetupCompleted) {
      navigate("/qrcode");
      return;
    }
    if (
      authContext.mfaSetupEnabled &&
      authContext.mfaSetupCompleted &&
      !authContext.mfaVerified
    ) {
      navigate("/mfa");
      return;
    }
  }, [authContext, navigate]);

   const loadMenus = useCallback(async () => {
    try {
      const res = await MenuService.GetMenus(authContext.userId, authContext);
      if (res.isSuccess) {
        setMenus(res.data.map(formatMenu));
      } else {
        AlertService.error(res.errorMessage);
      }
    } catch {
      AlertService.error("Failed to load menus");
    }
  }, [authContext, formatMenu]);

  useEffect(() => {
    loadMenus();
  }, [loadMenus]);

    useEffect(() => {
    setIsSidebarOpen(false);
  }, [location.pathname]);

  return (
    <BreadcrumbProvider>
      <div className="h-screen flex flex-col bg-[#fdfbfb] dark:bg-slate-950 p-0">
        <Navbar toggleSidebar={() => setIsSidebarOpen(true)} />
        <div className="flex flex-1 overflow-hidden">
          {/* Sidebar */}
          <Sidebar
            menus={menus}
            isOpen={isSidebarOpen}
            closeSidebar={() => setIsSidebarOpen(false)}
          />

          {/* Overlay (mobile only) */}
          {isSidebarOpen && (
            <div
              onClick={() => setIsSidebarOpen(false)}
              className="fixed inset-0 bg-black/50 z-20 md:hidden"
            />
          )}

          {/* Page Content */}

       <main className="flex-1 flex flex-col overflow-hidden ps-4 pt-2 md:ps-6 text-gray-800 dark:text-gray-100">
  
  {/* Breadcrumb – FIXED (no scroll) */}
 <div className="shrink-0 sticky top-0 z-10 bg-[#fdfbfb] dark:bg-slate-950">
  <Breadcrumbs />
</div>
  <div className="flex-1 overflow-y-auto overflow-x-hidden pe-4 pt-2 scroll-smooth ">
    <Outlet />
  </div>

</main>

        </div>
      </div>
    </BreadcrumbProvider>
  );
};
export default MainLayout;
